import { string } from 'yup';

const obj = {
  field: [
    {
      title: "Product",
      attr: "content",
      value: "",
      id: "product",
      placeholder: "Sneakers",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Product is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Target Audience",
      attr: "content",
      value: "",
      id: "targetAudience",
      placeholder: "Athletic men",
      label: "Target Audience",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Target Audience is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Region",
      attr: "content",
      value: "",
      id: "region",
      placeholder: "USA",
      label: "Target Audience",
      label: "Region",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Region is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Tone",
      id: "tone",
      placeholder: "Informative",
      label: "Tone",
      attr: "content",
      value: "",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	  let text || "Hello World"; 
	  console.log(text);
	  }`,
    },
    { 
			title: "Content length", 
			attr: "content",  
			value: 250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("noOfTokens is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
  ],

  example: [
    {
      title: "Product",
      attr: "content",
      value: "Sneakers",
      id: "product",
      placeholder: "Sneakers",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Product is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },

    {
      title: "Target Audience",
      attr: "content",
      value: "Athletic men",
      id: "targetAudience",
      placeholder: "Athletic men",
      label: "Target Audience",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Target Audience is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },

    {
      title: "Region",
      attr: "content",
      id: "region",
      placeholder: "USA",
      value: "USA",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Region is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },

    {
      title: "Tone",
      attr: "content",
      value: "Informative",
      id: "tone",
      placeholder: "Informative",
      label: "Tone",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    { 
			title: "Content length", 
			attr: "content",  
			value: 250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("noOfTokens is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
  ],

  editor: {
    output: `Dear Athletic Men,\nAre you looking for the perfect pair of sneakers to help you get the most out of your workouts? Look no further! Our new line of sneakers is designed to provide maximum comfort and support while keeping your feet dry and cool. With a lightweight design and breathable fabric, these shoes are sure to take your workouts to the next level. Plus, they come in a variety of colors so you can find the perfect style that fits your look.\n Don't settle for anything less than what you deserve when it comes to athletic footwear. Get our new sneakers today and experience all-day comfort that will keep up with even your toughest workouts.\nThanks for being an athlete! `,
  
  },
  // field:[

  //     {
  // 		title: "Keyword research for PPC",
  // 		attr: "content",
  // 		value: "",
  // 		id:"product",
  // 		placeholder: "function Name(attr){...",
  // 		label: "Place some code above to understand how it works",
  // 		type: "code",
  // 		maxLength: 2000,
  // 		// max: 100,
  // 		min: 3,
  // 		required: true,
  // 		error: "",
  // 		type: "textarea",
  // 		example: `function HelloWorld(text){
  // let text || "Hello World";
  // console.log(text);
  // }`,
  // 	},
  // ],

  // example:[

  //     {
  // 		title: "Keyword research for PPC",
  // 		attr: "content",
  // 		value: "currentPrompt",
  // 		id:"product",
  // 		placeholder: "function Name(attr){...",
  // 		label: "Place some code above to understand how it works",
  // 		type: "code",
  // 		maxLength: 2000,
  // 		// max: 100,
  // 		min: 3,
  // 		required: true,
  // 		error: "",
  // 		type: "textarea",
  // 		example: `function HelloWorld(text){
  // let text || "Hello World";
  // console.log(text);
  // }`,
  //     },

  //     {
  // 		title: "Keyword research for PPC",
  // 		attr: "content",
  // 		value: "currentPrompt",
  // 		id:"region",
  // 		placeholder: "function Name(attr){...",
  // 		label: "Place some code above to understand how it works",
  // 		type: "code",
  // 		maxLength: 2000,
  // 		// max: 100,
  // 		min: 3,
  // 		required: true,
  // 		error: "",
  // 		type: "textarea",
  // 		example: `function HelloWorld(text){
  // let text || "Hello World";
  // console.log(text);
  // }`,
  //     },

  //     {
  // 		title: "Keyword research for PPC",
  // 		attr: "content",
  // 		value: "currentPrompt",
  // 		id:"targetAudience",
  // 		placeholder: "function Name(attr){...",
  // 		label: "Place some code above to understand how it works",
  // 		type: "code",
  // 		maxLength: 2000,
  // 		// max: 100,
  // 		min: 3,
  // 		required: true,
  // 		error: "",
  // 		type: "textarea",
  // 		example: `function HelloWorld(text){
  // let text || "Hello World";
  // console.log(text);
  // }`,
  //     },

  //     {
  // 		title: "Keyword research for PPC",
  // 		attr: "content",
  // 		value: "currentPrompt",
  // 		id:"tone",
  // 		placeholder: "function Name(attr){...",
  // 		label: "Place some code above to understand how it works",
  // 		type: "code",
  // 		maxLength: 2000,
  // 		// max: 100,
  // 		min: 3,
  // 		required: true,
  // 		error: "",
  // 		type: "textarea",
  // 		example: `function HelloWorld(text){
  // let text || "Hello World";
  // console.log(text);
  // }`,
  // 	},
  // ],

  // editor:{
  // 	output:`
  //     Subject Line: Get the Most Out of Your Workouts with New Sneakers

  //     Dear Athletic Men,
  //      Are you looking for the perfect pair of sneakers to help you get the most out of your workouts? Look no further! Our new line of sneakers is designed to provide maximum comfort and support while keeping your feet dry and cool. With a lightweight design and breathable fabric, these shoes are sure to take your workouts to the next level. Plus, they come in a variety of colors so you can find the perfect style that fits your look.
  //     Don't settle for anything less than what you deserve when it comes to athletic footwear. Get our new sneakers today and experience all-day comfort that will keep up with even your toughest workouts.
  //     Thanks for being an athlete!  `
  // }
};

export default obj;
